module.exports = __webpack_public_path__ + "static/media/link.566479a3.svg";